import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { axiosPublic } from 'app/utils';
import type { Envelope } from 'app/utils/api-envelope';

export interface TokenValidity {
  used: boolean;
  expired: boolean;
  source: string;
}

async function validateResetToken(token: string): Promise<TokenValidity> {
  const { data } = await axiosPublic.get<Envelope<{ isValid: TokenValidity }>>(
    `/passwordreset/${token}`
  );
  if (data.error) throw new Error(data.error.text || data.error.message || 'Request failed');
  if (!data.data[0]) throw new Error('Response malformed');

  return data.data[0].isValid;
}

export function useValidateResetToken(token: string | undefined): UseQueryResult<TokenValidity> {
  return useQuery<TokenValidity>({
    queryKey: ['passwordreset-token', token],
    queryFn: () => {
      if (!token) throw new Error('Missing reset token');
      return validateResetToken(token);
    },
    enabled: Boolean(token),
    retry: false,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
}
